var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._b({class:_vm.chipClass,attrs:{"text-color":_vm.textColor,"color":_vm.color,"x-small":_vm.xSmall,"small":_vm.small}},'v-chip',_vm.$attrs,false),[_c('v-icon',{staticClass:"mr-1",attrs:{"color":_vm.textColor,"small":_vm.small || _vm.xSmall}},[_vm._v(" mdi-currency-usd ")]),_vm._v(" "+_vm._s(_vm.name)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }